<template>
  <v-container class="pa-0">
    <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
      <page-header-title :title="page_title"></page-header-title>
    </v-app-bar>

    <v-form ref="form">
      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  v-model="coursetypegroup.fullname"
                  :label="$t('drivingtests.coursetypegroup_id')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  v-model="coursetype.fullname"
                  :label="$t('drivingtests.coursetype_id')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  v-model="course.name"
                  :label="$t('drivingtests.course_id')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  v-model="participant.full_name"
                  :label="$t('drivingtests.participant_id')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="drivingtest.instructor_id"
                  v-model="instructor.fullname"
                  :label="$t('drivingtests.instructor_id')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="drivingtest.class_id"
                  v-model="classes.name"
                  :label="$t('drivingtests.class_id')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="drivingtest.date"
                  :value="computedDate"
                  :label="$t('drivingtests.date')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  name="drivingtest.time"
                  :value="computedTime"
                  :label="$t('drivingtests.time')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex lg3 md4 sm6 xs12>
                <v-text-field
                  :value="this.$dd_drivingtest_status(drivingtest.status)"
                  :label="$t('drivingtests.status')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  name="drivingtest.place"
                  v-model="drivingtest.place"
                  :label="$t('drivingtests.place')"
                  readonly
                  autocomplete="new-password"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-textarea v-model="drivingtest.description" :label="$t('drivingtests.description')" readonly></v-textarea>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
export default {
  name: "DrivingTestView",

  props: ["id", "locale"],

  data() {
    return {
      page_title: "",
      drivingtest: {},
      coursetypegroup: {},
      coursetype: {},
      participant: {},
      course: {},
      instructor: {},
      classes: {}
    }
  },

  computed: {
    computedDate() {
      return this.drivingtest.date ? this.moment.utc(this.drivingtest.date).format(this.DATE_FORMAT) : ""
    },
    computedTime() {
      return this.drivingtest.time ? this.moment.utc(this.drivingtest.time, this.TIME_FORMAT).format(this.TIME_FORMAT) : ""
    }
  },

  created() {
    axios
      .get(this.API_URL + "open/drivingtest/" + this.id)
      .then((res) => {
        this.drivingtest = res.data.data
        this.coursetypegroup = this.drivingtest.coursetypegroup
        this.coursetype = this.drivingtest.coursetype
        this.participant = this.drivingtest.participant
        this.course = this.drivingtest.course
        this.instructor = this.drivingtest.instructor
        this.classes = this.drivingtest.class
        this.page_title = this.$t("drivingtests.view_drivingtest", { name: this.drivingtest.id })
      })
      .catch((err) => console.log(err))
  }
}
</script>

<style scoped></style>
